import { useMemo } from 'react';

import { atom, useAtomValue } from 'jotai';
import { loadable } from 'jotai/utils';

import { renderSnapshot } from '../client/cache';

import type { EchoSnapshot } from '../types';
import type { Loadable } from 'jotai/vanilla/utils/loadable';

/**
 * This function is used to fetch an Echo response while you render.
 */
export function useEchoSnapshot(url: string): Loadable<EchoSnapshot> {
  const snapshotAtom = useMemo(() => {
    return loadable(atom(async (_, { signal }) => renderSnapshot({ url, signal })));
  }, [url]);

  return useAtomValue(snapshotAtom);
}
